<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar v-if="DonationCategory" :title="`Invoices By Donation Category`" />

        <v-container fluid>
          <table class="center">
            <tbody class="report-container">
              <v-card-text class="pt-0">
                <v-data-table
                  dense
                  :headers="headers"
                  :expanded.sync="expanded"
                  show-expand
                  :itemsPerPage="DonationCategory.length"
                  hide-default-footer
                  :items="DonationCategory"
                >
                  <template v-slot:item="{ item, isExpanded, expand }">
                    <tr>
                      <td class="text-left ">
                        <v-btn
                          class="no-print"
                          @click="expand(true)"
                          icon
                          v-if="!isExpanded"
                          ><v-icon>mdi-chevron-down</v-icon></v-btn
                        >
                        <v-btn
                          class="no-print"
                          @click="expand(false)"
                          icon
                          v-if="isExpanded"
                          ><v-icon>mdi-chevron-up</v-icon></v-btn
                        >
                      </td>
                      <td class="text-left">{{ item.name }}</td>
                    </tr>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-0">
                      <v-card color="#F3F8FC" flat>
                        <v-card-text class="title">
                          <Invoice :DonationCategoryId="item.id" :start="start" :end="end" :includeDetails="true" ></Invoice>
                        </v-card-text>
                      </v-card>
                    </td>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import donationCategoryService from "@/modules/DonationCategory/service";
import Invoice from "@/modules/ReportView/components/invoice/components/Invoice.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isLoading: true,
      DonationCategory: null,
      start: null,
      end: null,
      expanded: [],
      headers: [
        { text: "", value: "data-table-expand" },
        {
          text: "Category Name",
          align: "left",
          value: "name",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
  },
  created() {
    this.loadData();
    if (!this.currentBusiness) this.initUser();
  },
  components: { ReportViewBar, Invoice },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    loadData() {
      this.start = this.$route.query.start;
      this.end = this.$route.query.end;
      return donationCategoryService
        .getAll()
        .then((response) => {
          this.$Progress.finish();
          this.DonationCategory = response.data;
          document.title = `Report - DonationCategory Invoice`;

          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .no-print {
    display: none;
  }
  .detailBox {
    overflow: visible;
    height: 100%;
  }
  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}
.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}
.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
</style>
